import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import ko from './locales/ko.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';
import { matchSupportedLanguage, LANGUAGE_LOCALE_CODES } from './lib/localeMatch';

const resources = {
  en: { translation: en },
  es: { translation: es },
  zh: { translation: zh },
  ja: { translation: ja },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  ko: { translation: ko },
  pt: { translation: pt },
  ar: { translation: ar },
};

// Initial UI language is auto-detected from the browser; once a user is signed in, it
// tracks their nativeLanguage instead (see AuthContext's applyUserLanguage).
const detectedLanguageName = matchSupportedLanguage(typeof navigator !== 'undefined' ? navigator.language : null);
const initialLng = LANGUAGE_LOCALE_CODES[detectedLanguageName] || 'en';

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: initialLng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });
}

export default i18n;
